import { pluginNames } from './plugins';

const pluginsOrder = [
  pluginNames.FAST_SWIPE,
  pluginNames.ARROWS,
  pluginNames.SLIDES_TO_SHOW,
  pluginNames.AUTOPLAY,
  pluginNames.INFINITE,
  pluginNames.RTL,
  pluginNames.CLICK_TO_CHANGE,
  pluginNames.CENTERED,
  pluginNames.SLIDES_TO_SCROLL,
];

export default pluginsOrder;
